var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "xl",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n            Close Modal\n        ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.close_modal },
                  },
                  [_vm._v("\n                Закрити\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.save_location },
                  },
                  [_vm._v("\n               Зберегти\n            ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_users_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _c("h2", [
                _c("span", { staticClass: "fw-300" }, [
                  _vm._v("ID:" + _vm._s(this.doc.id)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-2" },
            [
              _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
                !_vm.is_load
                  ? _c(
                      "div",
                      { staticClass: "location_data" },
                      [
                        _vm.doc.id > 0
                          ? _c(
                              "b-tabs",
                              { attrs: { "content-class": "mt-3" } },
                              _vm._l(_vm.draw_tabs, function (tab, index) {
                                return _c(
                                  "b-tab",
                                  {
                                    key: index,
                                    attrs: { title: _vm.get_tab_title(tab) },
                                    on: {
                                      click: function ($event) {
                                        return _vm.set_active(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "title" },
                                      [
                                        _vm._t(
                                          "title_" + tab.index,
                                          function () {
                                            return [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    _vm.get_tab_title(tab)
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          },
                                          { doc: _vm.doc }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _vm._t(
                                      tab.index,
                                      function () {
                                        return [
                                          _c(tab.index, {
                                            tag: "component",
                                            attrs: { doc: _vm.doc },
                                            on: {
                                              doc_change: _vm.change_param,
                                            },
                                          }),
                                        ]
                                      },
                                      { doc: _vm.doc }
                                    ),
                                  ],
                                  2
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }